import { call, put, takeEvery, delay, select, fork, cancel, take } from 'redux-saga/effects';
import {
  GET_CHANNEL_INFO, CREATE_INTERFACE_INFO, SAVE_EXTRACTION_INFO, SAVE_PORT_SETUPS,
  SAVE_REFERENCE_NETS, UPDATE_SIGNAL_NAME, UPDATE_SIGNAL_NETS, DELETE_SIGNAL_NET,
  ADD_SIGNAL_NET, SAVE_D2D_CONTENT_TO_SERVER, CONFIG_OPERATION, EDIT_COMPONENT_PIN_TABLE,
  SAVE_PIN_MODEL, SAVE_POWER_OFF, SAVE_MODEL_PINS, SAVE_STIMULUS, UPDATE_SIGNAL_GROUP,
  UPDATE_ALL_CONTENT, EDIT_COMPONENT_TABLE, UPDATE_COMPLIANCE, EDIT_SAME_TYPE_COMPONENT_PIN_TABLE
} from './actionType';
import { RockyD2DInterface } from '../../../../services/Rocky/D2D/helper/identificationHelper';
import DesignInfo from '@/services/Rocky/pcbInfo';
import { getDefaultPortSetupList, getDefaultReferenceNets, getPortGenerateSetupList, getUpdateCompBallInfoByPinSize } from '../../../../services/ExtractionPortsHelper';
import { checkRLCValue } from '@/services/helper/dataProcess';
import { ICComponent, ICCompModel, BasicCompModel, RLCCONComponent, BasicComponent } from '@/services/Rocky';
import { getComponentsWithNetList } from '../../../../services/PCBHelper';
import { RockyInterposerCompRLCPrefixLib } from '../../../../services/Rocky/helper/setupClass';
import { BGA, DIE, IGNORE, UNUSED } from '../../../../constants/componentType';
import { createD2DChannelPromise, updateD2DChannelContentPromise, updateAllComponentPinsUsage, updateICPinModelsByBuffer, setDefaultUsageByDriver, getD2dSetupTableData, updateComponentUsageToPinsUsage, updateComponentPinsUsageByGroup, updateComponentPinsUsageOpposite } from '../../../../services/Rocky/D2D';
import D2DChannelConstructor from '../../../../services/Rocky/D2D/constructors/channelConstructor';
import { updateD2DChannelInfo, updateD2DLoading, updateExpandedGroup, updateIsEditing } from './action';
import { splitComponentName } from '@/services/helper/splitComponent';
import { CIRCUIT, GAP, PIN_GROUP, SPHEROID, WAVE, BALL_TYPE_NONE } from '@/services/ExtractionPortsHelper';
import { getLayoutPCBInfo } from '../rocky/saga';
import { D2D_CHANNEL } from '../../../../constants/treeConstants';
import { openProject, updateTreeSelectedKeys, updateViewList } from '../project/action';
import { openPage, updateCurrentConfig } from '../rocky/action';
import { getDefaultName } from '../../../../services/helper/setDefaultName';
import D2DPromiseConstructor from '../../../../services/Rocky/D2D/constructors/projectConstructor';
import { checkCompsType, isPowerGND, RLC_TYPES } from '../../../../services/PCBHelper';
import LayoutData from '@/services/data/LayoutData';
import { CONTENT_KEY_INTERPOSER } from '../../../../services/Rocky/D2D/helper/contentHelper';
import { PROJECT_D2D } from '../../../../constants/projectVersion';
import { HFSS } from '../../../../constants/extractionType';
import { findReferenceNetsBySignal, getReferenceNetsBySignal } from '../../../../services/api/refNets';
import { FIND_REF_NET_FAILED, FIND_REF_NET_RUNNING, FIND_REF_NET_SUCCESS } from '../../../../constants/findRefNetsConstants';
import { changeConfigFormat, ConfigInfo, getVerificationConfigPromise, Model } from '../../../../services/Rocky';
import { applySignalModels, createPinToPinConfig, judgeModelUpdate, updateICPinModels, updatePinToPinConfig } from '../../../../services/Sierra';
import { getIbisModelList } from '../../../../services/Rocky/library';
import { INPUT, ONLY_DRIVER_MODEL_TYPES } from '../../../../services/LibraryHelper';
import { getInterfaceMonitor } from '../simulation/action';
import { generateSignalDataType, compareValuesWithFactorAndUnits, getDefaultCompliance } from '../../../../services/Rocky/D2D/helper/dataProcess';
import { getJsonComponentsWithNetList } from '../../../../services/Rocky/helper/setupDataJson';
import { ROCKY } from '../../../../constants/pageType';
import auroraDBJson from '../../../../services/Designs/auroraDbData';
import { AURORA_NGSPICE } from '../../../../constants/resolution';

const RLCType = ['RLC', 'Cap', 'Ind', 'Res'];
const ChipTypes = [DIE];
let autoSaveTask = null;
function* getChannelInfo(action) {
  const { channelId } = action;
  try {
    if (autoSaveTask) {
      yield cancel(autoSaveTask);
    }
    autoSaveTask = yield fork(autoSave);
    const res = yield call(D2DChannelConstructor.getChannelContentPromise, channelId, true)
    if (res && res.content) {
      const keys = Object.keys(res.content);
      for (let key of keys) {
        const { designId } = res.content[key];
        if (designId) {
          yield call(getLayoutPCBInfo, designId);
        }
      }
    }

    yield put(updateD2DLoading("contentLoading", false))
    yield put(updateD2DChannelInfo(res))
    yield call(configOperation, { verificationId: res.verificationId, projectId: res.projectId })
    yield put(getInterfaceMonitor(res.verificationId, D2D_CHANNEL));
    yield put(updateExpandedGroup({}));
  } catch (error) {
    console.error(error)
  }
}

function* createInterfaceInfo(action) {
  const { dataList, auroraJson, interfaceName } = action;
  try {
    const { RockyReducer: { project: { currentProjectId, projectList } } } = yield select();
    const currentProject = projectList.find(item => item.id === currentProjectId);
    const D2DType = currentProject ? currentProject.type : null;
    const interfacePoserInfo = dataList[0];
    const { id: pcbId, netList, selectNetList } = interfacePoserInfo;
    const content = new RockyD2DInterface(pcbId);
    const pcbInfo = DesignInfo.getPCBInfo(pcbId);
    const { nets } = auroraJson;
    const netsList = nets ? Array.from(nets.values()) : [];
    const selectSignals = netList.filter(item => selectNetList.includes(item.interfaceKey));
    let Signals = [], _nets = [];
    for (let signalInfo of selectSignals) {
      const { nets, name, group, signalType, displayName } = signalInfo.content[0];
      _nets = [..._nets, ...nets];
      const signalName = nets && nets.length ? nets[0] : name;
      Signals.push({ name: signalName, nets, group, signalType, displayName })
    }

    const setting = new RockyInterposerCompRLCPrefixLib();
    const componentsList = getJsonComponentsWithNetList({ netList: _nets, pcbId, COMP_PREFIX_LIB: setting })
    let components = [], existComponentsName = [];
    for (const comp of componentsList) {
      const { pin, name, net, value, part } = comp;
      let type = comp.type || "";
      if ([IGNORE, UNUSED].includes(type)) {
        if (name.includes(BGA)) {
          type = BGA
        } else {
          type = DIE
        }
      }
      const signalInfo = Signals.find(item => item.nets.includes(net))
      const signalName = signalInfo && signalInfo.name ? signalInfo.name : null;
      const signalGroup = signalInfo && signalInfo.group ? signalInfo.group : null;
      const signalType = signalInfo && signalInfo.signalType ? signalInfo.signalType : null;
      // Not exist component
      const _index = existComponentsName.indexOf(name);
      if (_index < 0) {
        let newComp;
        if (RLCType.includes(type)) {
          let _value = value;
          _value = checkRLCValue(value);
          // Cap 
          if (type === 'Cap') {
            _value = {
              r: "0",
              l: "0",
              c: _value || "0"
            }
          }
          newComp = new RLCCONComponent({ name, type, value: _value });
        } else if (ChipTypes.includes(type)) {
          newComp = new ICComponent({ name, type });
        } else {
          newComp = new BasicComponent({ name, type });
        }
        if (ChipTypes.includes(type)) {
          newComp.pins = [new ICCompModel({ pin, net, signal: signalName, haveCorner: true })];

          const updateBallInfo = getUpdateCompBallInfoByPinSize(newComp, pcbId, null, null, null, ROCKY);
          Object.keys(updateBallInfo).forEach(key => { newComp[key] = updateBallInfo[key] })
          if (updateBallInfo['ball_size']) {
            const ballSize = updateBallInfo['ball_size'];
            const updateBallSize = compareValuesWithFactorAndUnits(ballSize, pcbId, comp);
            if (newComp['ball_size'] && updateBallSize) {
              newComp['ball_size'] = updateBallSize;
            }
          }
        } else {
          newComp.pins = [new BasicCompModel({ pin, net, signal: signalName })];
        }
        newComp.part = part;
        if (type !== 'Connector' && newComp.pkg) {
          delete newComp.pkg;
        }
        if (newComp.pins) {
          newComp.pins.forEach(pin => {
            pin.group = signalGroup ? signalGroup : null;
            pin.signalType = signalType ? signalType : null;
          })
        }
        components.push(newComp);
        // Update components name list
        existComponentsName.push(name);
      } else {
        // Exsit component
        if (ChipTypes.includes(components[_index].type)) {
          let newComp = new ICCompModel({ pin, net, signal: signalName, haveCorner: true });
          newComp.group = signalGroup ? signalGroup : null;
          newComp.signalType = signalType ? signalType : null;
          components[_index].pins.push(newComp);
        } else {
          let newComp = new BasicCompModel({ pin, net, signal: signalName });
          newComp.group = signalGroup ? signalGroup : null;
          newComp.signalType = signalType ? signalType : null;
          components[_index].pins.push(new BasicCompModel(newComp));
        }
      }

    };
    content.Components = components;
    content.Signals = Signals;
    // get reference
    const powerNets = yield call(getPowerNets, { pcbId, signals: Signals, components: content.Components })
    content.PowerNets = powerNets;


    const ports_generate_setup_list = getPortGenerateSetupList({ components: content.Components, projectType: PROJECT_D2D });

    let referenceNets = getDefaultReferenceNets(content.PowerNets);
    if (netsList.find(item => item.name === "VSS") && !referenceNets.find(item => item === "VSS")) {
      referenceNets.push("VSS")
      content.PowerNets.push({
        name: "VSS",
        value: "0",
      })
    }
    const referenceZ0 = content.Port_setups && content.Port_setups.length ? content.Port_setups[0].z0 : 50;

    const { port_setups, ports_generate_setup_list: setupList } = getDefaultPortSetupList({
      components: content.Components,
      signals: content.Signals,
      pcbInfo: pcbInfo,
      referenceNets,
      designId: pcbId,
      ports_generate_setup_list: ports_generate_setup_list,
      types: ChipTypes,
      referenceZ0: referenceZ0,
      extractionType: /* extraction.channelType || */HFSS,
      isAuroraJson: true
    });
    content.ReferenceNets = referenceNets;
    content.Port_setups = port_setups;
    content.Ports_generate_setup_list = setupList;
    const compliance = getDefaultCompliance({ type: D2DType });

    const nameList = D2DPromiseConstructor.get(currentProjectId);
    const defaultName = getDefaultName({
      nameList,
      defaultKey: `Channel`,
      firstIndex: 1,
      key: "name"
    });
    const info = yield call(createD2DChannelPromise, { name: interfaceName ? interfaceName : defaultName, projectId: currentProjectId, content: { interposer: content } })
    if (info && info.id) {
      const { RockyReducer: { project: { currentProjectId } } } = yield select();
      yield put(openProject({ id: currentProjectId }));
      yield put(openPage({ pageType: D2D_CHANNEL, id: info.id }));
      yield call(configOperation, { verificationId: info.verificationId, projectId: currentProjectId, operationType: "create", compliance })
      let list = [];

      // if (layout !== 3) {
      //   list = viewList.filter(item => !pageLeftViewList.includes(item));
      //   list = [...list, D2D_CHANNEL];
      //   list = [...new Set(list)];
      // } else {
      list = [D2D_CHANNEL];
      // }
      yield put(updateViewList(list))
      // let selectKeys = selectedKeys.filter(item => {
      //   if (item) {
      //     const [_key] = strDelimited(item, "-");
      //     if (!pageLeftViewList.includes(_key)) {
      //       return item;
      //     }
      //   };
      //   return false;
      // });
      // selectKeys.push(`${D2D_CHANNEL}-${info.id}`);
      let selectKeys = [`${D2D_CHANNEL}-${info.id}`]
      yield put(updateTreeSelectedKeys(selectKeys))
    }


  } catch (error) {
    console.error(error)
  }
}

function* configOperation(action) {
  const { verificationId, operationType, projectId, config, id, compliance } = action;
  try {
    const defaultConfig = {
      clock: '3.2G',
      cycles: '10',
      timeStep: '20p',
      compliance: compliance || getDefaultCompliance({}),
      usageCompGroupApply: true,
      usageOppositeDirApply: true,
    }

    let _currentConfig = new ConfigInfo({ ...defaultConfig, notStateConfig: true });
    if (operationType === "create") {
      yield call(updatePinToPinConfig, { projectId, verificationId, config: _currentConfig })
    } else if (operationType === "update") {
      const { RockyReducer: { D2D: { projectId: d2dProjectId, verificationId: d2dVerificationId }, } } = yield select();
      const updateConfig = yield call(updatePinToPinConfig, {
        projectId: projectId ? projectId : d2dProjectId,
        verificationId: verificationId ? verificationId : d2dVerificationId,
        config,
        id
      })
      yield put(updateCurrentConfig(updateConfig))
    } else {
      let _config = yield call(getVerificationConfigPromise, { verificationId })
      let currentConfig = null;
      if (!_config) {
        let _config = yield call(updatePinToPinConfig, { projectId, verificationId, config: _currentConfig })
        currentConfig = changeConfigFormat({ ..._config });
      } else {
        currentConfig = changeConfigFormat({ ..._config })
      }
      yield put(updateCurrentConfig(currentConfig))
    }
  } catch (error) {
    console.error(error)
  }
}


function* getPowerNets(action) {
  try {
    const { pcbId, signals, components } = action;
    const key = yield call(findReferenceNetsBySignal, { signals: [{ pcbId, signals }] });
    if (!key) {
      //failed
      return [];
    }
    yield delay(1000);
    let res = yield call(getReferenceNetsBySignal, { key });
    let { status = 0, data = null } = res ? res : {};
    while (status === FIND_REF_NET_RUNNING) {
      yield delay(2000);
      res = yield call(getReferenceNetsBySignal, { key });
      if (!res) {
        break;
      }
      status = res.status;
      data = res.data;
    }

    if (status === FIND_REF_NET_FAILED || !data || !Array.isArray(data)) {
      //failed
      return [];
    }

    if (status === FIND_REF_NET_SUCCESS) {
      let compPowerNets = [];
      for (let comp of components) {
        if (!RLC_TYPES.includes(comp.type)) {
          continue;
        };
        for (let pin of comp.pins) {
          // power,ground nets
          if (!pin.signal) {
            compPowerNets.push(pin.net);
          }
        }
      };
      let currentPcbRefNets = data.find(item => item.pcbId === pcbId);
      let signalNets = [];
      signals.forEach(item => {
        if (item.nets && item.nets.length > 0) {
          signalNets = [...signalNets, ...item.nets]
        }
      })

      currentPcbRefNets.nets = currentPcbRefNets ? currentPcbRefNets.nets.filter(item => !signalNets.includes(item)) : null;
      if (!currentPcbRefNets || !Array.isArray(currentPcbRefNets.nets)) {
        return;
      }

      let powerNets = [];
      const _LayoutData = LayoutData.getLayout(pcbId);
      currentPcbRefNets.nets.forEach(item => {
        const _netInfo = _LayoutData ? _LayoutData.mNetManager.GetNetFromName(item) : null;
        const isPowerNets = isPowerGND(_netInfo);
        if (isPowerNets) {
          let value = item === 'VSS' ? '0' : '';
          powerNets.push({
            name: item,
            value: value,
          })
        }
      });
      return powerNets;
    }
  } catch (error) {
    console.error(error)
    return [];
  }
}

let lastTask;
function* autoSave() {
  let lastTask;
  while (true) {
    const newAction = yield take([SAVE_D2D_CONTENT_TO_SERVER]);
    let delayTime = 2000;
    if (newAction.type === SAVE_D2D_CONTENT_TO_SERVER) {
      if (lastTask) {
        yield cancel(lastTask);
      }
      lastTask = yield fork(debounce, delayTime, saveD2DContentVerifications, newAction);
    }
  }
}

function* saveD2DContentVerifications() {
  try {
    const { RockyReducer: { D2D: { content, id } } } = yield select();
    if (!id) { return }
    const _content = JSON.parse(JSON.stringify(content));
    for (let key of Object.keys(_content)) {
      _content[key].Signals = _content[key].Signals.filter(signal => signal.nets && signal.nets.length)
    }
    const data = { content: _content, d2dChannelId: id }

    const response = yield call(updateD2DChannelContentPromise, data)
    yield put(updateIsEditing(false));
    D2DChannelConstructor.setInfo(response.id, response)
  } catch (error) {
    console.error(error)
  }
}

function* debounce(time, callback, updateStatus) {
  yield delay(time);
  yield call(callback, updateStatus);
}

function* saveExtractionInfo(action) {
  try {
    const { RockyReducer: { D2D: { content, id } } } = yield select();
    const _content = { ...content }
    const { obj: { extraction, info } } = action;
    const { designId, type } = info;
    if (!designId || !type) { return };
    _content[type].extraction = extraction;
    yield call(updateAllContent, { id, content: _content })
  } catch (error) {
    console.error(error)
  }
}

function* savePortSetups(action) {
  try {
    const { RockyReducer: { D2D: { content, id } } } = yield select();
    const { data, ComponentSetups, contentKey } = action;
    let _content = JSON.parse(JSON.stringify(content));
    const designId = _content.interposer.designId;
    if (_content[contentKey]) {
      let Ports_generate_setup_list = _content[contentKey].Ports_generate_setup_list || [];
      _content[contentKey] = { ..._content[contentKey], ...data };
      if (_content[contentKey].Components && _content[contentKey].Components.length) {
        _content[contentKey].Components.forEach(comp => {
          const compName = splitComponentName(comp.name);
          const findComp = ComponentSetups.find(it => it.name === compName);
          const compPortSetup = Ports_generate_setup_list.find(it => it.component === compName) || { setup: {} };
          if (findComp) {
            if ([WAVE, PIN_GROUP, CIRCUIT, GAP].includes(compPortSetup.setup.portType)) {
              if (compPortSetup.setup.portType === GAP) {
                comp.gap_size = findComp.gap_size || "0";
              }
              comp.ball_type = findComp.ball_type;
              if (comp.ball_type === BALL_TYPE_NONE) {
                delete comp.ball_size;
                delete comp.ball_height;
              } else {
                comp.ball_size = findComp.ball_size;
                comp.ball_height = findComp.ball_height;
              }

              if (comp.ball_type === SPHEROID) {
                comp.ball_mid_diameter = findComp.ball_mid_diameter;
              } else {
                delete comp.ball_mid_diameter;
              }
            } else {
              delete comp.gap_size;
              delete comp.ball_size;
              delete comp.ball_height;
              delete comp.ball_mid_diameter;
              delete comp.ball_type;
            }
          }
          // if (comp.ball_size) {
          //   const updateBallSize = compareValuesWithFactorAndUnits(comp.ball_size, designId, comp);
          //   comp.ball_size = updateBallSize ? updateBallSize : comp.ball_size;
          // }
        })
      }
    }

    yield call(updateAllContent, { id, content: _content })
  } catch (error) {
    console.error(error)
  }
}

function* saveReferenceNet(action) {
  try {
    const { newReferenceNets, contentKey = CONTENT_KEY_INTERPOSER } = action;
    const { RockyReducer: { D2D: { content, id } } } = yield select();
    // newSignals
    const _content = JSON.parse(JSON.stringify(content));

    let PowerNets = _content[contentKey].PowerNets;
    PowerNets = PowerNets.filter(item => {
      if (item.value === "0" && !newReferenceNets.includes(item.name)) {
        return false
      }
      return true;
    })
    const newAddReferenceNets = newReferenceNets.filter(item => !_content[contentKey].ReferenceNets.includes(item))
    PowerNets = [...PowerNets, ...newAddReferenceNets.map(item => { return { name: item, value: "0" } })];

    _content[contentKey].ReferenceNets = [...newReferenceNets];
    _content[contentKey].PowerNets = [...PowerNets];

    yield call(updateAllContent, { id, content: _content })
  } catch (error) {
    console.error(error)
  }
}

function* updateSignalGroup(action) {
  try {
    const { record, prevRecord, contentKey = CONTENT_KEY_INTERPOSER, expandedRowKeys } = action;
    const { RockyReducer: { D2D: { content, id } } } = yield select();
    const { children = [] } = record;
    let signals = [record.signal];
    if (children.length) {
      signals = children.map(item => item.signal);
    }
    const newSignalGroup = record.group;
    const oldSignalGroup = prevRecord.group;

    const _content = JSON.parse(JSON.stringify(content));
    const { Signals, Components } = _content[contentKey];
    const newSignals = Signals.map(item => {
      const { name, group } = item;
      if (signals.includes(name) && group === oldSignalGroup) {
        item.group = newSignalGroup
      }
      return item
    })

    const newComponents = Components.map(item => {
      const { pins } = item;
      pins.forEach(pin => { if (signals.includes(pin.signal) && pin.group === oldSignalGroup) { pin.group = newSignalGroup; } })
      return { ...item, pins }
    })

    _content[contentKey].Components = newComponents;
    _content[contentKey].Signals = newSignals;
    yield call(updateAllContent, { id, content: _content })
    const list = yield call(getD2dSetupTableData, _content);
    yield call(updateExpandedKeys, { list, expandedRowKeys })
  } catch (error) {
    console.error(error)
  }
}

function* updateSignalName(action) {
  try {
    const { record, prevRecord, contentKey = CONTENT_KEY_INTERPOSER, expandedRowKeys } = action;
    const { RockyReducer: { D2D: { content, id } } } = yield select();

    const _content = JSON.parse(JSON.stringify(content));
    const { Signals, Components } = _content[contentKey];
    let updateName;
    const newSignals = Signals.map(item => {
      const { name, group, displayName } = item;
      if (prevRecord.displayName === displayName && prevRecord.group === group) {
        updateName = record.signal.replace(prevRecord.displayName, record.displayName);
        item.name = updateName;
        const { signalType, group: newGroup } = generateSignalDataType(record)
        item.signalType = signalType || '';
        item.group = newGroup;
        item.displayName = record.displayName.includes(newGroup) ? record.displayName.replace(newGroup, "") : record.displayName;
      }
      return item
    })

    const newComponents = Components.map(item => {
      const { pins } = item;
      pins.forEach(pin => { if (pin.signal === prevRecord.signal && pin.group === prevRecord.group) { pin.signal = updateName; } })
      return { ...item, pins }
    })
    _content[contentKey].Components = newComponents;
    _content[contentKey].Signals = newSignals;

    yield call(updateAllContent, { id, content: _content })
    const list = yield call(getD2dSetupTableData, _content);
    yield call(updateExpandedKeys, { list, expandedRowKeys })
  } catch (error) {
    console.error(error)
  }
}

function* updateExpandedKeys(action) {
  const { list, expandedRowKeys } = action;
  const { RockyReducer: { D2D: { expandedGroupKeys } } } = yield select();
  let _expandedGroupKeys = { ...expandedGroupKeys };
  const groupExpandMap = new Map();
  list.forEach(item => {
    if (expandedRowKeys.includes(item.key)) {
      if (!groupExpandMap.has(item.group)) {
        let groupLen = item.children ? item.children.length : 0;
        groupExpandMap.set(item.group, groupLen);
      } else {
        let groupLen = item.children ? item.children.length : 0;
        const expandLen = groupExpandMap.get(item.group) || 0;
        groupExpandMap.set(item.group, groupLen + expandLen);
      }
    }
  })
  const expandKeys = Object.keys(_expandedGroupKeys);
  if (!expandKeys || !groupExpandMap.size) {
    return;
  }
  expandKeys.forEach(key => {
    if (groupExpandMap.has(key)) {
      _expandedGroupKeys[key] = groupExpandMap.get(key);
    }
  })
  yield put(updateExpandedGroup(_expandedGroupKeys))
}

function* updateSignalNets(action) {
  try {
    const { obj } = action;
    const { signalNet, signal: signalName, type: contentKey, group } = obj;
    const { RockyReducer: { D2D: { content, id } } } = yield select();

    const _content = JSON.parse(JSON.stringify(content));
    const { Signals, Components, designId } = _content[contentKey];

    const auroraJson = yield call(auroraDBJson.getAuroraJson, designId)
    const netList = auroraJson.nets ? Array.from(auroraJson.nets.values()) : [];
    const currentPkgInfo = netList.find(item => item.name === signalNet);

    if (currentPkgInfo) {
      const { name, pins } = currentPkgInfo
      let _components = [...Components];
      const components = auroraJson.components ? Array.from(auroraJson.components.values()) : [];
      for (const [compName, pinNum] of pins) {
        const currentCompInfo = components.find(item => item.name === compName);
        const componentsIndex = _components.findIndex(item => item.name === compName);
        const _pinValue = {
          pin: pinNum && pinNum.length ? pinNum[0] : "",
          net: name,
          signal: signalName,
          group,
          corner: 'typ',
          pinModels: [],
          powerOff: '',
          usage: '',
          model: {}
        }
        if (componentsIndex > -1) {
          let pinsList = _components[componentsIndex].pins.filter(item => item.signal !== signalName || (item.signal === signalName && item.net === signalNet))
          _components[componentsIndex].pins = [...pinsList, _pinValue]
        } else {
          let type = checkCompsType(currentCompInfo.name, {}, currentCompInfo.pins.size, currentCompInfo.partName);
          if ([IGNORE, UNUSED].includes(type)) {
            if (currentCompInfo.name.includes(BGA) || currentCompInfo.partName.includes(BGA)) {
              type = BGA
            } else {
              type = DIE
            }
          }
          const bgaCompInfo = {
            pins: [_pinValue],
            part: currentCompInfo.partName,
            name: currentCompInfo.name,
            type,
            model: {}
          };
          _components.push(bgaCompInfo)
        }
      }

      const sortComponents = _components.sort(typeSort)
      function typeSort(a, b) {
        var order = [BGA, DIE]
        return order.indexOf(a.type) - order.indexOf(b.type);
      }

      const signals = Signals.map(item => {
        if (item.name === signalName) {
          return {
            ...item,
            nets: [signalNet]
          }
        }
        return {
          ...item
        }
      })
      _content[contentKey] = yield call(updateContentItemInfo, { info: _content[contentKey], components: sortComponents, signals, designId, d2dChannelId: id })

      yield call(updateAllContent, { id, content: _content })
    }
  } catch (error) {
    console.error(error)
  }
}

function* updateAllContent({ content, isImmediatelyUpdate }) {
  try {
    yield put(updateD2DChannelInfo({ content: content }))

    if (isImmediatelyUpdate) {
      if (lastTask) {
        yield cancel(lastTask);
      }
      yield call(saveD2DContentVerifications);
    } else {
      yield put({ type: SAVE_D2D_CONTENT_TO_SERVER })
    }
  } catch (error) {
    console.error(error)
  }
}

function* updateContentItemInfo({ info, components, signals, designId }) {
  try {
    const content = {
      ...info,
      Components: components,
      Signals: signals
    }
    const pcbInfo = yield call(getLayoutPCBInfo, designId);

    const ports_generate_setup_list = getPortGenerateSetupList({ components: components, projectType: PROJECT_D2D });
    const referenceZ0 = content.Port_setups && content.Port_setups.length ? content.Port_setups[0].z0 : 50
    const { port_setups, ports_generate_setup_list: setupList } = getDefaultPortSetupList({
      components: components,
      signals: content.Signals,
      pcbInfo: pcbInfo,
      referenceNets: content.ReferenceNets,
      designId: designId,
      ports_generate_setup_list: ports_generate_setup_list,
      referenceZ0: referenceZ0,
      extractionType: content.extraction && content.extraction.type ? content.extraction.type : HFSS,
      isAuroraJson: true
    });

    content.Port_setups = port_setups;
    content.Ports_generate_setup_list = setupList;
    return content;
  } catch (error) {
    console.error(error)
  }
}

function* deleteSignalNet(action) {
  try {
    const { record: { signal, group }, expandedRowKeys } = action;
    const { RockyReducer: { D2D: { content, id } } } = yield select();
    let _content = JSON.parse(JSON.stringify(content));
    for (let key of Object.keys(content)) {
      const { Components, Signals, designId } = content[key];
      const selectedSignals = Signals.filter(item => !(item.name === signal && item.group === group))
      let newComponents = [];
      for (let component of Components) {
        const { pins } = component;
        const filterPins = pins.filter(item => !(item.signal === signal && item.group === group))
        if (filterPins.length) {
          newComponents.push({
            ...component,
            pins: filterPins
          })
        }
      }
      _content[key] = yield call(updateContentItemInfo, { info: _content[key], components: newComponents, signals: selectedSignals, designId })
    }
    yield call(updateAllContent, { id, content: _content })
    const list = yield call(getD2dSetupTableData, _content);
    yield call(updateExpandedKeys, { list, expandedRowKeys })
  } catch (error) {
    console.error(error)
  }
}

function* addSignalNet(action) {
  try {
    const { expandedRowKeys } = action;
    const { RockyReducer: { D2D: { content } } } = yield select();
    let _content = JSON.parse(JSON.stringify(content));
    for (let key of Object.keys(content)) {
      const { Signals } = content[key];
      let addSignalName = getDefaultName({ nameList: Signals, defaultKey: 'Signal', isStartZero: true });
      _content[key].Signals = [...Signals, { name: addSignalName, nets: [], displayName: addSignalName, group: "Group" }]
    }
    yield put(updateD2DChannelInfo({ content: _content }))
    const list = yield call(getD2dSetupTableData, _content);
    yield call(updateExpandedKeys, { list, expandedRowKeys })
  } catch (error) {
    console.error(error)
  }
}

function* editComponentTable(action) {
  try {
    const { record, pcbType } = action;
    const { name, usage } = record;
    const { RockyReducer: { D2D: { content, id }, rocky: { currentConfig } } } = yield select();
    //updateIsEditing
    yield put(updateIsEditing(true));
    if (!content || !content[pcbType] || !content[pcbType].Components.length) { return }
    let editInterface = JSON.parse(JSON.stringify(content[pcbType]));
    let components = [...editInterface.Components];
    components = yield call(updateComponentUsageToPinsUsage, { components, name, usage, currentConfig })
    editInterface.Components = components;
    yield call(updateAllContent, { id, content: { ...content, [pcbType]: editInterface } })
  }
  catch (error) {
    console.error(error);
  }
}

function* editSameTypeComponentPinTable(action) {
  try {
    const { pcbType, pins, usage } = action;
    const {  component, group } = pins && pins.length ? pins[0] : {};
    const { RockyReducer: { D2D: { content, id } } } = yield select();

    if (!content || !content[pcbType] || !content[pcbType].Components.length) { return }
    let editInterface = JSON.parse(JSON.stringify(content[pcbType]));
    let components = [...editInterface.Components];

    let signals = [], compList = [];
    signals = pins.map(item => item.signal);
    compList = pins.map(item => `${item.pcbId}::${item.component}`);
    //update current component pin usage and model
    const compIndex = components.findIndex(comp => comp.name === component);
    pins.forEach(pinItem => {
      const { pin, net, signal } = pinItem;

      const pinModelIndex = components[compIndex].pins.findIndex(item =>
        item.pin === pin && item.net === net && item.signal === signal
      );
      components[compIndex].pins[pinModelIndex].usage = usage;
      // Delete model or not, stimulus
      const editItem = components[compIndex].pins[pinModelIndex];
      if (!editItem.model) {
        editItem.model = {};
      }
      const prevModelType = editItem.model.modelType
      const newUsage = editItem.usage;

      const shouldClear = (prevModelType && ONLY_DRIVER_MODEL_TYPES.includes(prevModelType) && newUsage === 'Receiver')
        || (prevModelType && INPUT.includes(prevModelType) && newUsage === 'Driver')

      //delete model by usage and model type
      if (editItem && editItem.model && editItem.model.libraryId && shouldClear) {
        components[compIndex].pins[pinModelIndex].model = {
          ...editItem.model,
          modelName: "",
          modelType: "",
          enableVoltage: ""
        }
      }
      if (editItem.usage === "Receiver") {
        editItem.pinModels = []
      }

      let deviceVcc = ""
      //update device vcc and pinModels (nd_pu,nd_pd,nd_in)
      if (editItem.usage === "Driver" && (!editItem.pinModels || !editItem.pinModels.length)) {

        editItem.pinModels = updateICPinModelsByBuffer({
          pinModels: editItem.pinModels,
          usage: editItem.usage,
          libType: editItem.model.libType,
          modelType: editItem.model.modelType || "I/O",
          pu: deviceVcc,
          pd: "0"
        })
      }
      components[compIndex].pins[pinModelIndex].pinModels = editItem.pinModels;
    })
    editInterface.Components = components;
    editInterface = yield call(setDefaultUsageByDriver, { content: editInterface, signals, compList, model: null, usageOppositeDirApply: false, usage: usage, group, usageCompGroupApply: false });
    yield call(updateAllContent, { id, content: { ...content, [pcbType]: editInterface } })
  } catch (error) {
    console.error(error)
  }
}

function* editComponentPinTable(action) {
  try {
    const { pcbType, record, usageApplyAll, usageCompGroupApply, usageOppositeDirApply } = action;
    const { component, pin, net, signal, pcbId, group } = record;
    const { RockyReducer: { D2D: { content, id } } } = yield select();

    if (!content || !content[pcbType] || !content[pcbType].Components.length) { return }
    let editInterface = JSON.parse(JSON.stringify(content[pcbType]));
    let components = [...editInterface.Components];

    let signals = [], compList = [];
    signals.push(record.signal);
    compList.push(`${pcbId}::${component}`);

    if (usageApplyAll) {
      components = yield call(updateAllComponentPinsUsage, { pcbId, components, component, usage: record.usage, signals, compList })
    } else {
      //update current component pin usage and model
      const compIndex = components.findIndex(comp => comp.name === component);
      const pinModelIndex = components[compIndex].pins.findIndex(item =>
        item.pin === pin && item.net === net && item.signal === signal
      );
      components[compIndex].pins[pinModelIndex].usage = record.usage;
      // Delete model or not, stimulus
      const editItem = components[compIndex].pins[pinModelIndex];
      if (!editItem.model) {
        editItem.model = {};
      }
      const prevModelType = editItem.model.modelType
      const newUsage = editItem.usage;

      const shouldClear = (prevModelType && ONLY_DRIVER_MODEL_TYPES.includes(prevModelType) && newUsage === 'Receiver')
        || (prevModelType && INPUT.includes(prevModelType) && newUsage === 'Driver')

      //delete model by usage and model type
      if (editItem && editItem.model && editItem.model.libraryId && shouldClear) {
        components[compIndex].pins[pinModelIndex].model = {
          ...editItem.model,
          modelName: "",
          modelType: "",
          enableVoltage: ""
        }
      }

      if (editItem.usage === "Receiver") {
        editItem.pinModels = []
      }

      let deviceVcc = ""
      //update device vcc and pinModels (nd_pu,nd_pd,nd_in)
      if (editItem.usage === "Driver" && (!editItem.pinModels || !editItem.pinModels.length)) {

        if (editItem.model.libType === "IBIS" && editItem.model.libraryId) {
          const models = yield call(getIbisModelList, { libraryId: editItem.model.libraryId, usage: '' }) || {}
          const modelInfo = models ? (models.models || []).find(item => item.name === editItem.model.modelName) : null;
          deviceVcc = modelInfo && modelInfo.deviceVcc && modelInfo.deviceVcc !== "NA" ? parseFloat(modelInfo.deviceVcc).toString() : "";
          components[compIndex].deviceVcc = deviceVcc || "";
        }

        editItem.pinModels = updateICPinModelsByBuffer({
          pinModels: editItem.pinModels,
          usage: editItem.usage,
          libType: editItem.model.libType,
          modelType: editItem.model.modelType || "I/O",
          pu: deviceVcc,
          pd: "0"
        })
      }

      components[compIndex].pins[pinModelIndex].pinModels = editItem.pinModels;
    }

    if (usageCompGroupApply) {
      components = yield call(updateComponentPinsUsageByGroup, { pcbId, components, component, usage: record.usage, signals, compList, group })
    }
    if (usageOppositeDirApply) {
      components = yield call(updateComponentPinsUsageOpposite, { pcbId, components, component, usage: record.usage, signals, compList, group })
    }

    editInterface.Components = components;
    editInterface = yield call(setDefaultUsageByDriver, { content: editInterface, signals, compList, model: null, usageOppositeDirApply, usage: record.usage, group, usageCompGroupApply });
    yield call(updateAllContent, { id, content: { ...content, [pcbType]: editInterface } })
  } catch (error) {
    console.error(error)
  }
}

function* savePowerOffMode(action) {
  const { record: { component, signal, pin, net, usage, pcbType = "interposer" }, powerOff, applyAll } = action;
  const { RockyReducer: { rocky: { rockyInfo }, project: { projectVersion }, D2D: { content, id } } } = yield select();
  if (!content || !content[pcbType] || !content[pcbType].Components.length) { return }
  let editInterface = JSON.parse(JSON.stringify(content[pcbType]));

  let components = [...editInterface.Components];

  const compIndex = components.findIndex(item => item.name === component);
  const comp = components[compIndex];
  if (applyAll) {//apply powerOff to all pins of same component
    components[compIndex].pins.forEach(pinItem => {
      pinItem.powerOff = powerOff;
    })
  } else {
    const pinModelIndex = comp.pins.findIndex(item =>
      item.net === net && item.pin === pin && item.signal === signal
    );
    components[compIndex].pins[pinModelIndex].powerOff = powerOff;
  }

  editInterface.Components = [...components];
  yield call(updateAllContent, { id, content: { ...content, [pcbType]: editInterface } })

}

function* saveModelPins(action) {
  const { record: { component, pin, net, signal, pcb, pcbId, pcbType = "interposer" }, pinModels, applyAll, applyAllDriver } = action;
  const { RockyReducer: { rocky: { rockyInfo }, project: { projectVersion }, D2D: { content, id } } } = yield select();
  if (!content || !content[pcbType] || !content[pcbType].Components.length) { return }
  let editingInterface = content[pcbType];
  let components = [...editingInterface.Components];
  const compIndex = components.findIndex(comp => comp.name === component);
  const pinModelIndex = components[compIndex].pins.findIndex(item =>
    item.pin === pin && item.net === net && item.signal === signal
  );
  components[compIndex].pins[pinModelIndex].pinModels = pinModels;

  const nd_pu = pinModels ? pinModels.find(item => item.pinName === "nd_pu") : null;
  if (applyAll || applyAllDriver) {
    //apply nd_in stimulus and type to all pins of same component and usage
    //apply nd_in stimulus and type to all pins of all driver pins

    if (applyAll) {
      components[compIndex].pins.forEach(pinItem => {
        if (pinItem.pin !== pin && pinItem.usage === "Driver") {
          pinItem.pinModels = updateICPinModels({
            pinModels: pinItem.pinModels,
            usage: pinItem.usage,
            libType: pinItem.model && pinItem.model.libType ? pinItem.model.libType : "IBIS",
            modelType: pinItem.model && pinItem.model.modelType ? pinItem.model.modelType : "I/O",
            newPinModels: pinModels
          });
        }
      })
    } else if (applyAllDriver) {
      //current interface
      components.forEach(item => {
        if (item.type === DIE && item.pins) {
          item.pins.forEach(pinItem => {
            if (pinItem.usage === "Driver") {
              const libType = pinItem.model && pinItem.model.libType ? pinItem.model.libType : "IBIS";
              const modelType = pinItem.model && pinItem.model.libType ? pinItem.model.libType : "I/O";

              pinItem.pinModels = updateICPinModels({
                pinModels: pinItem.pinModels,
                usage: pinItem.usage,
                libType,
                modelType,
                newPinModels: pinModels
              });
            }
          })
          item.deviceVcc = nd_pu && nd_pu.value ? nd_pu.value : item.deviceVcc
        }
      })
      //other interfaces
      // if (_Interfaces.length > 1) {
      //   for (let info of _Interfaces) {
      //     if (info.pcbId === pcbId || !info.content || !info.content.components) {
      //       continue;
      //     }

      //     info.content.components.forEach(item => {
      //       if (item.type === IC && item.pins) {
      //         item.pins.forEach(pinItem => {
      //           if (pinItem.usage === "Driver") {
      //             const libType = pinItem.model && pinItem.model.libType ? pinItem.model.libType : "IBIS";
      //             const modelType = pinItem.model && pinItem.model.libType ? pinItem.model.libType : "I/O";

      //             pinItem.pinModels = updateICPinModels({
      //               pinModels: pinItem.pinModels,
      //               usage: pinItem.usage,
      //               libType,
      //               modelType,
      //               newPinModels: pinModels
      //             });
      //           }
      //         })
      //         item.deviceVcc = nd_pu && nd_pu.value ? nd_pu.value : item.deviceVcc
      //       }
      //     })
      //   }
      // }
    }
  }
  components[compIndex].deviceVcc = nd_pu && nd_pu.value ? nd_pu.value : components[compIndex].deviceVcc
  editingInterface.Components = [...components];
  yield call(updateAllContent, { id, content: { ...content, [pcbType]: editingInterface } })
}

function* assignModel(action) {
  const { record: { component, signal, pin, net, libType, pcb, pcbId, usage, pcbType = "interposer" }, model, deviceVcc = "", pinModelsInfo, applyAll, applySignal } = action;
  const _libType = libType;

  const { RockyReducer: { D2D: { content, id } } } = yield select();
  if (!content || !content[pcbType] || !content[pcbType].Components.length) { return }
  let editingInterface = content[pcbType];
  let components = [...editingInterface.Components];

  const { enableVoltage, fileName, modelName, modelType, libraryId, version } = model;

  const compIndex = components.findIndex(item => item.name === component);
  const comp = components[compIndex];
  const pinModelIndex = (comp.pins || []).findIndex(item =>
    item.net === net && item.pin === pin && item.signal === signal
  );
  let pinModelObj = comp.pins[pinModelIndex];
  let prevModel = JSON.parse(JSON.stringify(pinModelObj.model || {}));

  if (!judgeModelUpdate(prevModel, model)) {
    return;
  }

  // update IBIS file and component
  if (libType && libraryId && fileName) {
    // find component
    const IBISComponent = yield call(findComponentByPin, libraryId, pin)
    const prevFile = comp.model && comp.model.files && comp.model.files[0]
    if (!prevFile || prevFile.libraryId !== libraryId || prevFile.fileName !== fileName) {
      components[compIndex].pkg = { type: 'None' }
    }
    components[compIndex].model = {
      files: [{
        type: libType,
        libraryId,
        component: IBISComponent || (prevFile && prevFile.libraryId === libraryId ? prevFile.component : ''),
        fileName,
        version
      }]
    }
  }

  if (applyAll) {//Apply to all pins of same component and same usage
    components[compIndex].pins.forEach(pinItem => {
      if (usage === pinItem.usage) {
        //update model
        const { enableVoltage, fileName, modelName, modelType, libraryId, version } = model;
        let newModel = new Model({
          libType: _libType,
          libraryId: libraryId,
          fileName,
          modelType,
          modelName,
          enableVoltage,
          version
        });
        pinItem.model = newModel;
        //update pin Models nd_pu,nd_pd voltage
        if (pinModelsInfo && usage === 'Driver') {
          const { pu, pd } = pinModelsInfo;
          pinItem.pinModels = updateICPinModelsByBuffer({
            pinModels: pinItem.pinModels,
            usage: pinItem.usage,
            libType: _libType,
            modelType,
            pu,
            pd
          });
        }
      }
    });

  } else {
    //update model
    let newModel = new Model({
      libType: _libType,
      libraryId: libraryId,
      fileName,
      modelType,
      modelName,
      enableVoltage,
      version
    });

    //update current pin model
    components[compIndex].pins[pinModelIndex].model = newModel;
    //update pin Models nd_pu,nd_pd voltage
    if (pinModelsInfo && usage === 'Driver') {
      let _pinModels = components[compIndex].pins[pinModelIndex].pinModels;

      const { pu, pd } = pinModelsInfo;
      _pinModels = updateICPinModelsByBuffer({
        pinModels: _pinModels,
        usage,
        libType: _libType,
        modelType,
        pu,
        pd
      });
      //TODO
      /* const findIN = _pinModels.findIndex(item => item.pinName === 'nd_in');
      //delete nd_in type when libType modified
      if (findIN > -1 && libType !== MultiPinSPICE && prevModel.libType === MultiPinSPICE && _pinModels[findIN].type === MultiPinSPICE) {
        _pinModels[findIN].type = "";
        _pinModels[findIN].stimulus = "";
      } */
      components[compIndex].pins[pinModelIndex].pinModels = _pinModels;
    }
  }

  const { pu } = pinModelsInfo || {};

  if (applySignal) {
    const pinModelIndex = comp.pins.findIndex(item =>
      item.net === net && item.pin === pin && item.signal === signal
    );
    const pinInfo = components[compIndex].pins[pinModelIndex]
    const IBISComponent = components[compIndex].model.files[0].component
    components = applySignalModels(components, pinInfo, IBISComponent, deviceVcc, pu)
  }


  components[compIndex].deviceVcc = deviceVcc || pu;
  editingInterface.Components = [...components];
  yield call(updateAllContent, { id, content: { ...content, [pcbType]: editingInterface } })
};

function* findComponentByPin(libraryId, pin) {
  const model = yield call(getIbisModelList, { libraryId, usage: '' })
  const { packages } = model || {};
  let IBISComponent = ''
  if (packages) {
    let pkg = packages.find(pkg => {
      let tmp = pkg.pinSection.find(item => item.pin === pin)
      if (tmp) return pkg.component
      else return false
    })
    if (pkg) IBISComponent = pkg.component
  }

  return IBISComponent
}

function* updateCompliance(action) {
  try {
    const { RockyReducer: { D2D: { content, id }, rocky: { currentConfig } } } = yield select();
    let Config = JSON.parse(JSON.stringify(currentConfig));
    let compliance = Config.configContent ? Config.configContent.compliance : {};
    const clock = Config.clock && Config.clock.unit ? `${Config.clock.value}${Config.clock.unit}` : Config.clock || "3.2G";
    const timeStep = Config.timeStep && Config.timeStep.unit ? `${Config.timeStep.value}${Config.timeStep.unit}` : Config.timeStep || "20p";
    if (compliance && !compliance.simulate) {
      compliance.simulate = AURORA_NGSPICE;
      compliance.ngspiceConfig = { ngspiceParallelism: 4 };
    }
    const updateConfig = {
      timeStep: timeStep,
      clock: clock,
      cycles: Config.cycles || 1,
      simulate: Config.configContent ? Config.configContent.simulate : "HSPICE",
      ngspiceMDFLM: Config.configContent ? Config.configContent.ngspiceMDFLM : "30ps",
      hspiceCores: Config.configContent ? Config.configContent.hspiceCores : 2,
      compliance: compliance || {},
      hspiceLicenses: Config.configContent ? Config.configContent.hspiceLicenses : 2,
    };
    const interposer = content.interposer;
    let components = interposer.Components;

    const txResValue = compliance && compliance.tx && compliance.tx.R ? compliance.tx.R.value : null;
    const txCapValue = compliance && compliance.tx && compliance.tx.C ? compliance.tx.C.value + "p" : "0.2p";
    const rxResValue = compliance && compliance.rx && compliance.rx.R ? compliance.rx.R.value : null;
    const rxCapValue = compliance && compliance.rx && compliance.rx.C ? compliance.rx.C.value + "p" : "0.2p";
    components.forEach(comp => {
      let pinCompliance = { R: null, C: null };
      if (comp.usage === 'Driver') {
        pinCompliance = { R: txResValue, C: txCapValue };
      } else if (comp.usage === 'Receiver') {
        pinCompliance = { R: rxResValue, C: rxCapValue };
      }
      if (!pinCompliance.R) {
        delete pinCompliance.R;
      }
      comp.pins.forEach(pin => {
        pin.compliance = { ...pinCompliance }
      })
    })
    const _content = { ...content, interposer: { ...interposer, Components: components } };
    yield call(updateAllContent, { id, content: _content });
    yield call(configOperation, { config: updateConfig, id: currentConfig.id, operationType: "update" })
  } catch (error) {
    console.error(error)
  }
}

function* D2DSaga() {
  yield takeEvery(GET_CHANNEL_INFO, getChannelInfo);
  yield takeEvery(CREATE_INTERFACE_INFO, createInterfaceInfo);
  yield takeEvery(SAVE_EXTRACTION_INFO, saveExtractionInfo);
  yield takeEvery(SAVE_PORT_SETUPS, savePortSetups);
  yield takeEvery(SAVE_REFERENCE_NETS, saveReferenceNet);
  yield takeEvery(UPDATE_SIGNAL_NAME, updateSignalName);
  yield takeEvery(UPDATE_SIGNAL_NETS, updateSignalNets);
  yield takeEvery(DELETE_SIGNAL_NET, deleteSignalNet);
  yield takeEvery(ADD_SIGNAL_NET, addSignalNet);
  yield takeEvery(CONFIG_OPERATION, configOperation);
  yield takeEvery(EDIT_COMPONENT_PIN_TABLE, editComponentPinTable);
  yield takeEvery(SAVE_PIN_MODEL, assignModel);
  yield takeEvery(SAVE_MODEL_PINS, saveModelPins);
  yield takeEvery(SAVE_POWER_OFF, savePowerOffMode);
  yield takeEvery(UPDATE_ALL_CONTENT, updateAllContent)
  yield takeEvery(UPDATE_SIGNAL_GROUP, updateSignalGroup)
  yield takeEvery(EDIT_COMPONENT_TABLE, editComponentTable);
  yield takeEvery(UPDATE_COMPLIANCE, updateCompliance);
  yield takeEvery(EDIT_SAME_TYPE_COMPONENT_PIN_TABLE, editSameTypeComponentPinTable);
}

export default D2DSaga;